import { z } from "zod";

export const GodAviRequestSchema = z.object({
  captureId: z.number().positive().min(1),
  godGId: z.number(),
  godOId: z.number(),
  godDId: z.number(),
});

export type GodAviRequest = z.infer<typeof GodAviRequestSchema>;